import { ModalNames } from '../modals/v2/Modal';
import { ModalRef } from './ModalRef.model';

export abstract class Modal {

    modalInstance: ModalRef;

  abstract onInjectInputs(inputs: any): void

  close(output?: any): void {
  	this.modalInstance.close(output);
  }

  dismiss(): void {
  	this.modalInstance.dismiss();
  }

  allowDimmerClose(): boolean {
  	return true;  
  }

  abstract getName(): ModalNames;

  getCloseResult(output: any): boolean { 
  	return output;
  }
}